import { ReactElement } from 'react';
import LayoutNoCTA from '@components/LayoutNoCTA';

interface ILayoutLightWithCartProps {
  children?: ReactElement<any>;
}

const LayoutLightWithCart: React.FC<ILayoutLightWithCartProps> = ({
  children,
}) => {
  return <LayoutNoCTA withCart>{children}</LayoutNoCTA>;
};

export default LayoutLightWithCart;
